import { CcdDateUtils } from '../../../../services/ccd-date.utils';
import { TypePersonneEnum } from '../../personne/enum/type-personne.enum';
import { ProprietesQuestionsSitProModel } from '../models/proprietes-questions-sitpro.model';
import { CcdBoutonModel } from '@cnaf.usagers.appli/cnaf-commons-dral/lib/techniques/ccd-boutons-radio/ccd-bouton.model';

/**
 * Classe de gestion des libelles pour les questions et réponses possibles, liées à la situation profesionnelle
 */
export class LibellesSitProService {

    constructor() {}

    /**
     * libelles des questions pour le demandeur
     */
    static getLibellesQuestionsDemandeur(dateJour : Date) : Map<string, string> {
        return new Map(
        [
            [ "Q1", "Vous êtes actuellement" ],
            [ "Q2", "Vous exercez toujours une activité professionnelle" ],
            [ "Q2.1", "Vous êtes au chômage depuis plus de 2 mois" ],
            [ "Q3", "Vous êtes toujours indemnisé en ".concat(this.getLibelleMoisMoins1(dateJour)) ]
        ]);
    }

    /**
     * libelles des questions pour le conjoint
     */
    static getLibellesQuestionConjoint(dateJour : Date) : Map<string, string> {
        return new Map(
        [
            [ "Q1", "Votre conjoint est actuellement" ],
            [ "Q2", "Votre conjoint exerce toujours une activité professionnelle" ],
            [ "Q2.1", "Votre conjoint est au chômage depuis plus de 2 mois" ],
            [ "Q3", "Votre conjoint est toujours indemnisé en ".concat(this.getLibelleMoisMoins1(dateJour)) ]
        ]);
    }

    /**
     * Détermination du libelle du mois - 1 de la date en cours
     * @param dateDuJour Date
     */
    static getLibelleMoisMoins1(dateDuJour : Date) : string {
        const dateMoisMoins1 = CcdDateUtils.getDateAvecMoisSupplementaire(dateDuJour, -1);
        let libelleMoisMoins1 : string;
        
        if (dateDuJour.getMonth() === 0) {
            libelleMoisMoins1 = CcdDateUtils.getLibelleMoisEtAnnee(dateMoisMoins1);
        } else {
            libelleMoisMoins1 = CcdDateUtils.getLibelleMois(dateMoisMoins1);
        }
        return libelleMoisMoins1;
    }

    /**
     * Réponses possibles pour la question 1
     */
    static LIBELLES_REPONSES_Q1 : Map<string, CcdBoutonModel> = new Map(
    [
        ["Q1_REP1", {libelle:"Bénéficiaire du RSA", code:"ST_RSA"}],
        ["Q1_REP2", {libelle:"Etudiant non boursier", code:"ETU"}],
        ["Q1_REP3", {libelle:"Etudiant boursier", code:"EBO"}],
        ["Q1_REP4", {libelle:"Dans une autre situation", code:"ACT_INCONNUE"}],
        ["Q1_REP5", {libelle:"En congé parental", code:"CONGE_MATPAT"}]
    ]);

     /**
     * Détermination des réponses possibles pour la question Q1.
     * 
     */
    static getReponsesSituation(nbEnfants : number) : any {
        const result = [];
        result.push(this.LIBELLES_REPONSES_Q1.get("Q1_REP1"));
        result.push(this.LIBELLES_REPONSES_Q1.get("Q1_REP2"));
        result.push(this.LIBELLES_REPONSES_Q1.get("Q1_REP3"));
        result.push(this.LIBELLES_REPONSES_Q1.get("Q1_REP4"));

        if (nbEnfants > 0) {
            result.push(this.LIBELLES_REPONSES_Q1.get("Q1_REP5"));
        }

        return result;
    }

    /**
     * Réponses OUI / NON
     */
    static LIBELLES_REPONSES_OUI_NON : Array<CcdBoutonModel> = [
        {libelle:"OUI", code:"true"},
        {libelle:"NON", code:"false"}
    ];

    /**
     * Determination des libelles
     * 
     * @param typePersonne  TypePersonneEnum
     * @param nbEnfants nombre d'enfants 
     */
    static determinerLibelles(
        typePersonne : TypePersonneEnum, 
        nbEnfants : number, 
        dateDuJour : Date) : ProprietesQuestionsSitProModel {

        const result = new ProprietesQuestionsSitProModel();

        let mapLibellesQuestions : Map<string, string>;
        if (typePersonne === TypePersonneEnum.DEMANDEUR) {
            mapLibellesQuestions = this.getLibellesQuestionsDemandeur(dateDuJour);
        }
        else if (typePersonne === TypePersonneEnum.CONJOINT) {
            mapLibellesQuestions = this.getLibellesQuestionConjoint(dateDuJour);
        }
    
        result.libelleQuestionSituation = mapLibellesQuestions.get("Q1");
        result.libelleQuestionActiviteProfessionnelle = mapLibellesQuestions.get("Q2");
        result.libelleQuestionChomage = mapLibellesQuestions.get("Q2.1");
        result.libelleQuestionIndemnise = mapLibellesQuestions.get("Q3");

        result.reponsesQuestionSituation = this.getReponsesSituation(nbEnfants);
        result.reponsesQuestionActiviteProfessionnelle = this.LIBELLES_REPONSES_OUI_NON;
        result.reponsesQuestionChomage = this.LIBELLES_REPONSES_OUI_NON;
        result.reponsesQuestionIndemnise = this.LIBELLES_REPONSES_OUI_NON;

        return result;
    }
}
